import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";
import { Modal } from "rsuite";
const ShareModalDiv = ({
  open,
  close,
}: {
  open: boolean;
  close: () => void;
}) => {
  const url = window.location.origin + window.location.pathname;
  return (
    <Modal size={"xs"} open={open} onClose={close}>
      <Modal.Body>
        <div className="w-100 d-flex justify-content-center gap-2">
          <FacebookShareButton url={url}>
            <FacebookIcon
              size={"2rem"} // You can use rem value instead of numbers
              round
            />
          </FacebookShareButton>

          <TwitterShareButton url={url}>
            {/* <TwitterShareButton title={title}> */}
            <TwitterIcon size={"2rem"} round />
          </TwitterShareButton>

          <WhatsappShareButton url={url}>
            <WhatsappIcon size={"2rem"} round />
          </WhatsappShareButton>

          <LinkedinShareButton url={url}>
            <LinkedinIcon size={"2rem"} round />
          </LinkedinShareButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ShareModalDiv;
